module.exports = __webpack_public_path__ + "img/es.a471956.png";